import { render, staticRenderFns } from "./DownloadGameFooterMobile.vue?vue&type=template&id=27c27aa1&scoped=true"
import script from "./DownloadGameFooterMobile.vue?vue&type=script&lang=js"
export * from "./DownloadGameFooterMobile.vue?vue&type=script&lang=js"
import style0 from "./DownloadGameFooterMobile.vue?vue&type=style&index=0&id=27c27aa1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c27aa1",
  null
  
)

export default component.exports